import { ONE_HOUR, ONE_MINUTE } from "./constants";

export const padZero = (number, length = 2) => {
  let string = String(number);
  const threshold = Math.pow(10, length - 1);

  if (number < threshold) {
    while (String(threshold).length > string.length) {
      string = `0${number}`;
    }
  }

  return string;
};

export const shouldRenderHoursInput = duration => {
  const hours = Math.floor(duration / ONE_HOUR);

  return hours > 0;
};

export const formatTime = (timeInSeconds, showHours) => {
  const hours = Math.floor(timeInSeconds / ONE_HOUR);
  const minutes = Math.floor((timeInSeconds % ONE_HOUR) / ONE_MINUTE);
  const seconds = timeInSeconds % ONE_MINUTE;

  return showHours
    ? `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`
    : `${padZero(minutes)}:${padZero(seconds)}`;
};

export const parseTime = timeString => {
  const parts = timeString
    .split(":")
    .map(part => (part === "" ? NaN : parseInt(part, 10)));
  if (parts.some(isNaN) || parts.length > 3) {
    return 0;
  }

  if (parts.length === 1) {
    return parts[0];
  } else if (parts.length === 2) {
    return parts[0] * ONE_MINUTE + parts[1];
  } else if (parts.length === 3) {
    return parts[0] * ONE_HOUR + parts[1] * ONE_MINUTE + parts[2];
  }

  return 0;
};

export const validateInput = input => {
  const regex = /^[0-9:]{0,8}$/;
  const colons = (input.match(/:/g) || []).length;

  return regex.test(input) && colons <= 2;
};
